import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";

import moment from "moment";

Vue.prototype.moment = moment;
Vue.use(VueAxios, axios);

let currency = window.localStorage.getItem("currency_symbol");

const getDefaultMenuItemState = () => {
    return {
        menuItems: [],
        storeCategories: [],
        tempMenu: [],
        outletInfo: [],
        charges: [],
        isLoading: false,
        tempCategories: [],
        tempSearchCategories: [],
        selected_outlet_id: null,
        selected_outlet_name: "",
        isOpen: false,
        currency_symbol: currency ? currency : "",
        custom_message_store_offline: "",
        digital_order_settings: [],
        formname: "",
        promocode: [],
    };
};

// initial state
const state = getDefaultMenuItemState();

/*
const state = {
    menuItems: [],
    storeCategories:[],
    tempMenu:[],
    outletInfo:[],
    charges:[],
    isLoading:false,
    tempCategories:[],
    tempSearchCategories:[],
    selected_outlet_id:null,
    selected_outlet_name:'',
    isOpen:false,
    currency_symbol:currency?currency:'',
    custom_message_store_offline:'',
    digital_order_settings:[],
    formname:'',
    promocode:[]
};*/
const getters = {
    allMenuItems: (state) => state.tempMenu,
    allStoreCategories: (state) => state.storeCategories,
    outletInformation: (state) => state.outletInfo,
    additionalCharges: (state) => state.charges,
    setLoaderValue: (state) => state.isLoading,
    tempCategories: (state) => state.tempCategories,
    tempSearchCategories: (state) => state.tempSearchCategories,
    setOutletID: (state) => state.selected_outlet_id,
    setOutletName: (state) => state.selected_outlet_name,
    isOpen: (state) => {
        var start;
        var close;
        var today = new Date();
        var h = today.getHours();
        var m = today.getMinutes();
        var s = today.getSeconds();
        var now = h + ":" + m + ":" + s;

        state.outletInfo.forEach((item) => {
            start = item.day_start_time;
            close = item.day_close_time;
        });

        var format = "hh:mm:ss";
        var time = moment(now, format);
        var beforeTime = moment(start, format);
        var afterTime = moment(close, format);

        /*  console.log("time "+time)
            console.log("beforeTime "+beforeTime)
            console.log("afterTime "+afterTime)*/

        if (time.isBetween(beforeTime, afterTime)) {
            //  console.log('is between')
            state.isOpen = true;
        } else {
            // console.log('is not between')
            state.isOpen = false;
        }

        return state.isOpen;
    },
    custom_message_store_offline: (state) => {
        state.outletInfo.forEach((item) => {
            state.custom_message_store_offline =
                item.digital_ordering_settings.customer.custom_msg_when_store_offline;
        });

        return state.custom_message_store_offline;
    },
    currency_symbol: (state) => {
        state.outletInfo.forEach((item) => {
            // alert(item.day_start_time)
            // alert(item.day_close_time)

            state.currency_symbol = item.currency_symbol;
        });

        // alert("now time "+now)
        // alert("Start time "+start)
        //alert("close time "+close)

        localStorage.setItem("currency_symbol", state.currency_symbol);

        return state.currency_symbol;
    },
    digital_order_setting: (state) => {
        let digital_order_enabled;
        let description;
        let preparation_time;
        let dinein;
        let pickup;
        let delivery;
        let whatsapp;
        let ask_for_ordertype_before_placing_order;
        let promo_code_on_dinein;
        let promo_code_on_delivery;
        let promo_code_on_pickup;
        let reject_order;
        let order_later;
        let order_later_days_limit;
        let todays_date;
        let day_start_time;
        let day_close_time;
        let login_method;
        let order_limit_dinein;
        let order_limit_pickup;
        let order_limit_delivery;
        let digi_whatsapp_msg;
        let digi_whatsapp_no;

        let show_fb;
        let show_call;
        let show_insta;
        let show_website;
        let show_linkedin;
        let show_pinterest;

        let fb_url;
        let call_url;
        let insta_url;
        let website_url;
        let linkedin_url;
        let pinterest_url;

        let ask_email_while_registration;
        let email_login;

        let order_later_time_slots = {};

        state.outletInfo.forEach((item) => {
            digital_order_enabled = item.digital_ordering;
            description = item.digital_ordering_settings.items.description;
            preparation_time = item.digital_ordering_settings.items.preparation_time;

            dinein = item.digital_ordering_settings.other.dinein;
            pickup = item.digital_ordering_settings.other.pickup;
            delivery = item.digital_ordering_settings.other.delivery;
            whatsapp = item.digital_ordering_settings.other.show_whatsapp_link;
            ask_for_ordertype_before_placing_order =
                item.digital_ordering_settings.other
                    .ask_for_ordertype_before_placing_order;
            promo_code_on_dinein =
                item.digital_ordering_settings.customer.promocode.dinein;
            promo_code_on_delivery =
                item.digital_ordering_settings.customer.promocode.delivery;
            promo_code_on_pickup =
                item.digital_ordering_settings.customer.promocode.pickup;
            reject_order = item.digital_ordering_settings.customer.reject_order;
            order_later = item.digital_ordering_settings.customer.order_later;
            order_later_days_limit = item.order_later_days_limit;
            todays_date = item.todays_date;
            day_start_time = item.day_start_time;
            day_close_time = item.day_close_time;
            login_method = item.digital_ordering_settings.customer.login_method;
            order_limit_delivery =
                item.digital_ordering_settings.order_limit.delivery;
            order_limit_dinein = item.digital_ordering_settings.order_limit.dinein;
            order_limit_pickup = item.digital_ordering_settings.order_limit.pickup;
            digi_whatsapp_msg = item.digi_whatsapp_msg;
            digi_whatsapp_no = item.digi_whatsapp_no;

            show_fb = item.digital_ordering_settings.social_media.show_fb;
            show_call = item.digital_ordering_settings.social_media.show_call;
            show_insta = item.digital_ordering_settings.social_media.show_insta;
            show_linkedin = item.digital_ordering_settings.social_media.show_linkedin;
            show_website = item.digital_ordering_settings.social_media.show_website;
            show_pinterest =
                item.digital_ordering_settings.social_media.show_pinterest;

            fb_url = item.digital_ordering_settings.social_media.fb;
            call_url = item.digital_ordering_settings.social_media.call;
            insta_url = item.digital_ordering_settings.social_media.insta;
            website_url = item.digital_ordering_settings.social_media.website;
            linkedin_url = item.digital_ordering_settings.social_media.linkedin;
            pinterest_url = item.digital_ordering_settings.social_media.pinterest;
            ask_email_while_registration =
                item.digital_ordering_settings.customer.ask_email_while_registration;
            email_login = item.digital_ordering_settings.customer.email_login;

            order_later_time_slots =
                item.digital_ordering_settings.customer.order_later_time_slots;
            /* item.digital_ordering_settings.customer.order_later_time_slots.forEach(
              (time) => {
                order_later_time_slots.push(time);
              }
            ); */
        });

        state.digital_order_settings = {
            digital_order_enabled,
            description,
            preparation_time,
            pickup,
            dinein,
            delivery,
            whatsapp,
            ask_for_ordertype_before_placing_order,
            promo_code_on_delivery,
            promo_code_on_dinein,
            promo_code_on_pickup,
            reject_order,
            order_later,
            order_later_days_limit,
            todays_date,
            day_start_time,
            day_close_time,
            login_method,
            order_limit_delivery,
            order_limit_dinein,
            order_limit_pickup,
            digi_whatsapp_no,
            digi_whatsapp_msg,
            show_fb,
            show_call,
            show_insta,
            show_linkedin,
            show_pinterest,
            show_website,
            fb_url,
            call_url,
            insta_url,
            website_url,
            linkedin_url,
            pinterest_url,
            ask_email_while_registration,
            email_login,
            order_later_time_slots,
        };

        //   alert(JSON.stringify(state.digital_order_settings))

        return state.digital_order_settings;
    },
    getFormName: (state) => state.formname,
    viewAllPromoCode: (state) => state.promocode,
};
const actions = {
    async getMenuItems({ commit, state }) {

        if (state.selected_outlet_id) {
            const response = await axios.get("menu/" + state.selected_outlet_id);
            commit("setMenuItems", response.data.storeMenuItems);
            commit("tempMenuItems", response.data.storeMenuItems);
            commit("setStoreCategories", response.data.storeCategories);
            commit("setOutletInfo", response.data.outlet);
            commit("setAdditionalCharges", response.data.charges);
        }
    },

    async getSelectedMenu({ commit }, { category_ref_ids }) {
        commit("GET_SELECTED_MENU_ITEMS", { category_ref_ids });
    },

    async setValueToLoader({ commit }, value) {
        commit("SET_VALUE_TO_LOADER", { value });
    },

    async getSearchedMenu({ commit }, { category_ref_ids }) {
        commit("GET_SEARCHED_MENU_ITEMS", { category_ref_ids });
    },

    async setOutlet({ commit }, outlet_id) {
        // console.log("outlet_id is in actions "+outlet_id)
        commit("SET_OUTLET", { outlet_id });
    },
    async setOutletName({ commit }, outlet_name) {
        // alert(outlet_name)
        // console.log("outlet_id is in actions "+outlet_id)
        commit("SET_OUTLET_NAME", { outlet_name });
    },
    async getFilteredFood({ commit }, { selected_food_filter }) {
        //console.log("selected_food_filter "+selected_food_filter)
        commit("GET_FILTERED_MENU_ITEMS", { selected_food_filter });
    },
    async setFormName({ commit }, from_name) {
        // alert(outlet_name)
        // console.log("outlet_id is in actions "+outlet_id)
        commit("GET_FORM_NAME", { from_name });
    },

    async getAllPromoCode({ commit, state }) {
        let store_id;

        state.outletInfo.find((outlet) => {
            store_id = outlet.store_id;
        });

        const response = await axios.get("promos?store_id=" + store_id);
        commit("setPromoCode", response.data.promocodes);
    },

    async resetMenuItemState({ commit }) {
        commit("resetMenuItemState");
    },
};
const mutations = {
    setMenuItems: (state, menuItems) => (state.menuItems = menuItems),
    tempMenuItems: (state, tempMenu) =>
        //alert(JSON.stringify(tempMenu)),
        (state.tempMenu = tempMenu),
    setStoreCategories: (state, storeCategories) => {
        // (state.storeCategories = storeCategories)

        //console.log("storeCategories before sort "+JSON.stringify(storeCategories))

        storeCategories.sort(function (a, b) {
            return a.category_sort > b.category_sort ?
                1 :
                b.category_sort > a.category_sort ?
                    -1 :
                    0;
        });

        //  console.log("storeCategories after sort "+JSON.stringify(storeCategories))
        state.storeCategories = storeCategories;
    },
    tempCategories: (state, tempCategories) =>
        (state.tempCategories = tempCategories),
    tempSearchCategories: (state, tempSearchCategories) =>
        (state.tempSearchCategories = tempSearchCategories),
    setOutletInfo: (state, outletInfo) => (state.outletInfo = outletInfo),
    setAdditionalCharges: (state, charges) => (state.charges = charges),
    GET_SELECTED_MENU_ITEMS: (state, { category_ref_ids }) => {
        if (category_ref_ids != "all") {
            //console.log("the selected id is in if "+ category_ref_ids)
            state.tempMenu = state.menuItems;
            state.tempMenu = state.tempMenu.filter((item) => {
                return item.category_ref_ids == category_ref_ids;
            });

            state.tempCategories = state.storeCategories;
            state.tempCategories = state.tempCategories.filter((category) => {
                return category.category_refid == category_ref_ids;
            });
        }

        if (category_ref_ids == "all") {
            //  alert(category_ref_ids)
            state.tempMenu = state.menuItems;
            state.tempCategories = state.storeCategories;
        }
    },
    GET_SEARCHED_MENU_ITEMS: (state, { category_ref_ids }) => {
        // console.log("in search "+category_ref_ids)

        state.tempMenu = state.menuItems;
        state.tempCategories = state.storeCategories;

        if (category_ref_ids != "all") {
            // alert("Not all "+category_ref_ids)
            state.tempMenu = state.tempMenu.filter((item) => {
                let title = item.title.toUpperCase();
                let search_string = category_ref_ids.toUpperCase();

                if (title.includes(search_string) > 0) {
                    state.tempSearchCategories = state.tempSearchCategories.filter(
                        (category) => {
                            // console.log("tempSearchCategories "+JSON.stringify(state.tempSearchCategories))
                            // console.log("category ID "+category.category_refid)
                            // console.log("category ref id "+item.category_ref_ids)

                            return category.category_refid === item.category_ref_ids;
                        }
                    );

                    return item.title;
                }
            });
        } else if (category_ref_ids == "all") {
            // alert("in all "+category_ref_ids)
            state.tempMenu = state.menuItems;
        }

        //  console.log("in search "+JSON.stringify(state.tempSearchCategories))

        //console.log("tempMenu "+JSON.stringify(state.tempMenu))
    },
    SET_VALUE_TO_LOADER: (state, value) => (state.isLoading = value),
    SET_OUTLET: (state, { outlet_id }) => {
        // console.log("outlet_id is in mutations "+outlet_id)

        state.selected_outlet_id = outlet_id;

        localStorage.setItem("selected_outlet_id ", state.selected_outlet_id);
    },
    SET_OUTLET_NAME: (state, { outlet_name }) => {
        // console.log("outlet_id is in mutations "+outlet_id)

        state.selected_outlet_name = outlet_name;

        localStorage.setItem("selected_outlet_name ", state.selected_outlet_name);
    },

    GET_FORM_NAME: (state, { from_name }) => {
        // console.log("outlet_id is in mutations "+outlet_id)

        state.formname = from_name;
    },

    GET_FILTERED_MENU_ITEMS: (state, { selected_food_filter }) => {
        state.tempMenu = state.menuItems;

        if (selected_food_filter.length > 0) {
            state.tempMenu = state.tempMenu.filter((item) => {
                // console.log("in GET_FILTERED_MENU_ITEMS "+selected_food_filter)

                let food_type = item.food_type;

                /*   var i
                        for (i = 0; i < selected_food_filter.length; i++) {
                            */

                if (selected_food_filter == "veg") {
                    //   console.log("In veg")

                    if (food_type == 1 || food_type == 3 || food_type == 4) {
                        //   console.log('food_type '+food_type)
                        return item.category_ref_ids;
                    }
                } else {
                    //  console.log("In nonveg")

                    if (food_type == 2) {
                        //  console.log('food_type '+food_type)
                        return item.category_ref_ids;
                    }
                }
                /* }*/
            });
        } else {
            state.tempMenu = state.menuItems;
            // state.tempCategories = state.storeCategories
        }

        //   console.log("tempMenu "+JSON.stringify(state.tempMenu))
    },
    setPromoCode: (state, promocode) => (state.promocode = promocode),
    resetMenuItemState(state) {
        // Merge rather than replace so we don't lose observers
        // https://github.com/vuejs/vuex/issues/1118
        Object.assign(state, getDefaultMenuItemState());
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};